import * as e from "react";
const r = (t) => /* @__PURE__ */ e.createElement("svg", { viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("rect", { fill: "#ff5a5f", height: 512, rx: "15%", width: 512 }), /* @__PURE__ */ e.createElement(
  "path",
  {
    d: "M255 83.7c-29 .1-40.6 23.9-40.6 23.9-36.2 66.5-70 134.2-101.2 203.2-17.2 38-4.6 68.2 14.8 84.5 36.8 31 82 13.4 126.5-38.7 34.3-40 49.8-73.2 48.3-100.6-1.3-23.9-15.8-43.7-47.9-43.7-47.3-.2-48.3 44.6-48.5 43.7 0 46.6 42.8 93.5 56 108.6 13.3 15.1 70.8 73.4 121.5 30 37.7-32.1 13.1-83.8 13.1-83.8-30.6-67.6-51-111.5-99.9-203.2 0 0-10.6-24-42.2-24v.1z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 23
  }
));
export {
  r as default
};
